import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef, Input, Injector } from '@angular/core';
import { Platform, ActionSheetController, ModalController, NavParams, NavController } from '@ionic/angular';
//import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { SplashScreen } from '@capacitor/splash-screen';
//import { StatusBar } from '@ionic-native/status-bar/ngx';
import { StatusBar, Style } from '@capacitor/status-bar';
import { AuthService } from 'src/app/auth/services/auth.service';
import { Router } from '@angular/router';
import { Storage } from '@ionic/storage';
import { AccountService, IApiAccount } from 'src/app/account/services/account.service';
import { ProfileService } from 'src/app/account/services/profile.service';
import { HttpHelpers } from '../../helpers/http.helpers';
import { LoaderService } from '../../services/loader.service';
import { SettingService } from '../../services/setting.service';
import { PageService } from 'src/app/services/page.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { StoreService, IStore } from 'src/app/store/services/store.service';
import { ActivatedRoute } from '@angular/router';
import { ItemBrandServiceService } from 'src/app/store/services/item-brand-service.service';
import { DomSanitizer } from '@angular/platform-browser';
import { NavigationEnd } from '@angular/router';
import { AlertService } from '../../services/alert.service';
//import { ItemService } from './store/services/item.service';
//import { Url } from 'url';
import { map, take } from 'rxjs/operators';
//import { CouponHelpers } from './shared/helpers/coupon.helpers';
import { CouponService } from '../../services/coupon.service';
//import { ModalDisplayComponent } from './shared/components/modal-display/modal-display.component';
import { ReservationConfigurationService } from '../../services/reservation-configuration.service';
import { ListPageComponent } from 'src/app/store/pages/list-page/list-page.component';
import { ReservationComponent } from 'src/app/reservation-page/pages/reservation-page/reservation-page.component';
import { OrderListPageComponent } from 'src/app/account/pages/order-list-page/order-list-page.component';
import { LocationsPageComponent } from 'src/app/pages/locations-page/locations-page.component';
import { PayRewardPageComponent } from 'src/app/account/pages/pay-reward-page/pay-reward-page.component';
import { OfferPageComponent } from 'src/app/account/pages/offer-page/offer-page.component';
import { ProfilePageComponent } from 'src/app/account/pages/profile-page/profile-page.component';
import { SupportHomePageComponent } from 'src/app/support/pages/support-home-page/support-home-page.component';
import { AuthenticationPageComponent } from 'src/app/auth/pages/authentication-page/authentication-page.component';
import { StoreListModalComponent } from 'src/app/store/modals/store-list-modal/store-list-modal.component';
import { AnalyticsService } from '../../services/analytics.service';
import { Capacitor } from '@capacitor/core';
import { TranslationService } from '../../services/translation.service';
import { MessagesComponent } from 'src/app/pages/messages/messages.component';
import { NavbarConfigurationService } from '../../services/navbar-configuration.service';
import { PlusPageComponent } from 'src/app/account/pages/plus-page/plus-page.component';
import { ApiControllerService } from '../../services/api-controller.service';
import { AllInOneAuthPageComponent } from 'src/app/auth/pages/all-in-one-auth-page/all-in-one-auth-page.component';
import { MenuService } from 'src/app/store/services/menu.service';



const CACHE_KEY = 'cartStorage';
export interface INavigationItem {
  title: string;
  url: string;
  icon: string;
  component?: any;
  notification?: any;
  imageActive?: any;
  imagePassive?: any;
  show?: (component: UndockedNavigationBarComponent) => boolean;
}

@Component({
    selector: 'app-undocked-navigation-bar',
    templateUrl: './undocked-navigation-bar.component.html',
    styleUrls: ['./undocked-navigation-bar.component.scss'],
    standalone: false
})
export class UndockedNavigationBarComponent implements OnInit {
primary: IApiAccount;
  public selectedIndex = 0;
  private addition = true;
  ipAddress: any;
  @ViewChild('toggleMenu',{read: ElementRef}) toggleMenu: ElementRef;
  @ViewChild('menuIcon',{read: ElementRef}) menuIcon: ElementRef;

  
  public disablePanel = true;
  public reservationAvailable: boolean = false;
  public showTableNavigation: boolean = false;

  @Input() disabledOption: string;
  largeIcon: boolean = true; // add a setting for that

  isPopup: boolean = false;


  ImageLoaded: boolean = false;
   
  navigating: boolean = false;

  useCustomNavItemBackground: boolean = false;
  animationEffect: string;
  customIconImage: any;

  // for UI animation
  //isAnimating: boolean = false;
  //openNav: boolean = false;


  // this simply checks if this menu should show up or not
  get navigationSetting() : boolean {
    
    if(this.setting.configuration.uIoptions) {
      if(this.setting.configuration.uIoptions?.unDockNavigationBar) {
        return false;
      }
    }
    return true;
  }
 
  public appPreviewPages : INavigationItem[] = [
    {
      title: 'Nav.Stores',
      url: '/stores',
      icon: 'restaurant'
    }
  ]
  public  appDefaultPages : INavigationItem[] = []; 
  public labels = ['Family', 'Friends', 'Notes', 'Work', 'Travel', 'Reminders'];

 
  public appPages : INavigationItem[] = this.appDefaultPages;
  get isTenant() {
    if (environment.deviceApp)
      return true;

    return (HttpHelpers.getSubdomain());
  }

  get name() {
    return this.setting?.name;
  }

  get logo() {
    if (environment.deviceApp)
      return '/assets/logo.png';

    return this.setting.logo;
  }

  get icon() {
    if (environment.deviceApp)
      return '/assets/logo.png';

    if (!this.setting.icon)
      return this.logo;
       
    return this.setting.icon;
  }

  get facebook() {
    return this.setting.facebook;
  }

  get instagram() {
    return this.setting.instagram;
  }

  get twitter() {
    return this.setting.twitter;
  }

  get supportedLanguages() {
    if (this.setting.configuration) {
      return this.setting.configuration.supportedLanguages;
    }   
  }

  get currentLanguages() {
    return this.translationService.getLanguage(); 
  }

  get routeUrl(){
    return this.router.url;
  }

  get profilePageVersion() {

    if(this.setting.configuration.uIoptions?.extendedSettings) {
      return {
        title: 'Nav.Profile',
        url: '/account/plus',
        icon: 'person-circle',
        component: PlusPageComponent, 
        show: (component) => !component.setting.configuration.hideMemberProgram
      };
    } else {
      return {
        title: 'Nav.Profile',
        url: '/account/profile',
        icon: 'person-circle',
        component: ProfilePageComponent, 
        show: (component) => !component.setting.configuration.hideMemberProgram
      };
    }
  }

  
  languageExist: boolean=false;
  constructor(private http: HttpClient,
    private modalCtrl: ModalController,
    private route: ActivatedRoute,
    private itemBrandService: ItemBrandServiceService,
    private sanitizer: DomSanitizer,
    private platform: Platform,
    //private splashScreen: SplashScreen,
    //private statusBar: StatusBar,
    //private translate: TranslateService,
    public auth: AuthService,
    private router: Router,
    private actionSheetController: ActionSheetController,
    private storage: Storage,
    public setting: SettingService,
    public accountService: AccountService,
    private storeService: StoreService,
    private cdr: ChangeDetectorRef,
    private loader: LoaderService,
    private couponService: CouponService,
    private alertService: AlertService,
    private reservationConfigurationService: ReservationConfigurationService,
    private injector: Injector,
    private element: ElementRef,
    private navCtrl: NavController,
    private authService: AuthService,
    private analytics: AnalyticsService,
    private translationService: TranslationService,
    public navbarConfigurationService: NavbarConfigurationService,
    private apiController: ApiControllerService,
    private menuService: MenuService
 ) {
   // this.initializeApp();
    this.sanitizer = sanitizer;

    // init here due to new format ----- to change the icon and use the set icons, add it here
    this.appDefaultPages = [
      {
        title: 'Nav.Home',
        url: '/home',
        icon: 'home'
      },
      {
        title: 'Nav.Stores',
        url: '/stores',
        icon: 'restaurant',
        component: StoreListModalComponent
      },
      {
        title: 'Nav.PlaceTableOrder',
        url: '/stores/table-order',
        icon: 'wine',
        component: StoreListModalComponent,
        show: (component) => component.showTableNavigation
      },
      {
        title: 'Nav.MyOrders',
        url: '/account/my-orders',
        icon: 'newspaper',
        component: OrderListPageComponent,
        show: (component) => component.auth.isAuthenticated
      },
      {
        title: 'Nav.Pay&Reward',
        url: '/account/pay-rewards',
        icon: 'star-half',
        component: PayRewardPageComponent,
        show: (component) => !component.setting.configuration.hideMemberProgram
      }, 
      {
        title: 'Nav.Offers',
        url: '/account/offers',
        icon: 'pricetags',
        component: OfferPageComponent,
        notification: this.getAvailableCoupons(),
        show: (component) => !component.setting.configuration.hideMemberProgram || !component.setting.configuration.hideECouponProgram
      },
      {
        title: 'Nav.Reservation',
        url: '/reservation',
        icon: 'calendar',
        component: ReservationComponent,
        //show: (component) => component.setting.configuration.showReservation
        show: (component) => component.reservationAvailable
      },
      {
        title: this.setting.configuration ? (this.setting.configuration.storeCount > 1 ?  'Nav.Locations' : 'Nav.Location') : 'Nav.Locations',
        url: '/locations',
        icon: 'compass',
        component: LocationsPageComponent
      },
      {
        title: 'Nav.Account',
        url: '/account',
        icon: 'card',
        show: (component) => !component.setting.configuration.hideMemberProgram
      },
        
      
      // {
      //   title: 'Nav.MyFavorites',
      //   url: '/myfavorites',
      //   icon: 'heart',
      //   show: (component) => !component.setting.configuration.hideMemberProgram
      // },
      /*{
        title: 'Nav.Reservation',
        url: '/reservation',
        icon: 'calendar'
      },
      
      {
        title: 'Nav.Friends',
        url: '/chat',
        icon: 'people'
      },*/
      {
        title: 'Nav.Support',
        url: '/support',
        icon: 'mail-open',
        component: SupportHomePageComponent,
      },
      /*
      {
        title: 'Nav.Profile',
        url: '/account/profile',
        icon: 'person-circle',
        component: ProfilePageComponent, 
        show: (component) => !component.setting.configuration.hideMemberProgram
      },*/
      this.profilePageVersion,
      
      /*,
      {
        title: 'Profile',
        url: '/profile',
        icon: 'person-circle'
      },
      {
        title: 'Login test',
        url: '/auth',
        icon: 'person-circle'
      },
      {
        title: 'Sign out',
        url: '',
        icon: 'log-out'
      }*/
    ];

    //////////////////////////////////////////////////////////////////////
    // load navbar images (if it has any)
    this.loadNavBarCustomImg()

    // modify the accessible link based on the configs
    this.editNavigation();
    //////////////////////////////////////////////////////////////////////

    // temporary fix for the "supported language. set a default language first before proceeding to changing it"
    this.setDefaultLanguage('fr');
    this.validateSupportedLanguage();

    router.events.subscribe((e) => {
      let currentRoute = this.route.root;
   
      while (currentRoute.children[0] !== undefined) {
        currentRoute = currentRoute.children[0];
        if (e instanceof NavigationEnd) {
         
          if(currentRoute.snapshot.params.language)
          {
            
            if(currentRoute.snapshot.params.language == 'en' || currentRoute.snapshot.params.language == 'fr')
            {
              
              this.languageExist = true;
              this.translationService.setLanguage(currentRoute.snapshot.params.language);
              localStorage['lang'] = currentRoute.snapshot.params.language;
            }
          }
        }
      }

    });
    
  }

  validateSupportedLanguage() {
    let languages = this.supportedLanguages;

    if (!languages) {
      this.setDefaultLanguage('fr');
      return;
    }

    if (languages.length != 0) {
      languages.forEach(lang => {
        if (lang.isFavorite) {
          this.setDefaultLanguage(lang.name.toLowerCase());
          return;
        }
      })
    } else {
      this.setDefaultLanguage('fr');
    }
  }

  setDefaultLanguage(lang: string) {
    this.translationService.setLanguage(lang);
    //this.translate.currentLang = lang;
  }

  /*
  initializeApp() {
    this.platform.ready().then(async () => {
      this.clearCache();
      //this.statusBar.styleDefault();
      if (Capacitor.isNativePlatform()) {
        await StatusBar.setStyle({ style: Style.Default });
      }
      await SplashScreen.hide();
    });
  }
  */
  ngAfterContentChecked() {
    this.disablePanel = this.setting.disablePanel;
    this.cdr.detectChanges();
  }

  ngOnInit() {
    this.selectedIndex = this.navbarConfigurationService.getSelectedNav;

    // Only access NavParams if running inside a modal (which confirms if the navigation is within a popup)
    const navParams = this.injector.get(NavParams, null);
    try {
      if(navParams.get('disableHeader') != undefined) {
        this.isPopup = true;
      }
    } catch (e) {

    }

    /////////////////////////////////////////////////////////////////////////////////////////////////
    // here we setup the config for the homepage
    const hostElement = this.element.nativeElement;

    const host = hostElement;

    if(this.setting.configuration.uIoptions?.unDockNavigationBarColor) {
      host.style.setProperty('--navbar-color', this.setting.configuration.uIoptions?.unDockNavigationBarColor);
    }
     
    if(this.setting.configuration.uIoptions?.unDockNavigationBarIconColor) {
      host.style.setProperty('--navbar-icon-color',this.setting.configuration.uIoptions?.unDockNavigationBarIconColor);
    }
    /////////////////////////////////////////////////////////////////////////////////////////////////

    this.previewPageMode();
    /* this.http.get('https://api.ipify.org/?format=json').subscribe(ip=>{
      this.ipAddress = ip;
      this.setting.ipAddress = this.ipAddress.ip;
    }); */
    this.apiController.get('https://api.ipify.org/?format=json').subscribe(ip=>{
      this.ipAddress = ip;
      this.setting.ipAddress = this.ipAddress.ip;
    });
   
    if(this.setting)
    { 
      let merchantId = this.setting.getMerchantId()
      this.itemBrandService.getBrands(merchantId).subscribe(data => {
        this.itemBrandService.itemBrands = data;
      });
    
      if(this.setting.configuration.customFont != null)
      {
          this.fontStyle();
      }  
      this.setting.disablePanel = true;
     if(this.setting.configuration)
     {
        //These two will tell either the store sells food or retail or both of them
            this.setting.foodItems = this.setting.configuration.foodItems;
            this.setting.retailItems = this.setting.configuration.retailItems;
            this.showTableNavigation = this.setting.configuration.showTableNavigation && this.setting.configuration.allowTable;
     }
      // Call getAvailableCoupons() twice a day
    var halfDay = 12 * 60 * 60 * 1000;
    
    setInterval(() => {
      this.getAvailableCoupons();
    },
      halfDay);
     
      this.storeService.getStores()
      .pipe(take(1))
      .subscribe(stores => {
        stores.forEach(store => {
          this.reservationConfigurationService.findReservationConfiguration(store.id).subscribe(config => {
            if(config && config.useReservation){
              this.reservationAvailable = true;
            }
          });
        });
      });
    }
  
    this.auth.logOut$.subscribe(() => {
      this.clearCache();
    });
    const path = window.location.pathname.split('folder/')[1];
    if (path !== undefined) {
      this.selectedIndex = this.appPages.findIndex(page => page.title.toLowerCase() === path.toLowerCase());
    }
    

    //Logic of deleting the cart
    let tracker = new Date();
    let ExpirationTime = tracker.getDate();
   
    if(ExpirationTime > localStorage['TimeLimit'] || (localStorage['TimeLimit'] >= 30 && ExpirationTime == 1))
    { localStorage.removeItem(CACHE_KEY);
      localStorage.removeItem("TimeLimit");
      localStorage.removeItem("StoreId");
    }
  
      if(localStorage.getItem('lang'))
      {
        let lang = localStorage.getItem('lang');
        this.translationService.setLanguage(lang.toLowerCase());  
      
      }
  

      this.dynamicResizer();
  }

  ngOnDestroy() {
 
  }

  applyExpandIcon(): string {

    if(this.setting.configuration.navBarConfiguration) {
      if(this.setting.configuration.navBarConfiguration.expansionNavBar) {
        return this.setting.configuration.navBarConfiguration.expansionNavBar;
      }
    }

    return 'menu';
  }

  editNavigation(){

    const config = this.setting.configuration?.navBarConfiguration;

    if (!config?.allActiveNavBarOptions?.length) {
      this.appPages = [...this.appDefaultPages];
      return;
    }

    //console.log(config.allActiveNavBarOptions);
    const activeOptions = config.allActiveNavBarOptions;

    const newNavOptions: INavigationItem[] = [];

    for (const active of activeOptions) {
      const page = this.appDefaultPages.find(
        p => p.title === active.value
      );

      if (page) {
        newNavOptions.push(page);
      }
    }

    this.appPages = newNavOptions;

  }

  async loadNavBarCustomImg() {

    if(this.setting.configuration.navBarConfiguration){

      // nav icon custom background
      if(this.setting.configuration.navBarConfiguration.customNavActiveImageShortName){
        this.customIconImage = await this.navbarConfigurationService.fetchImage(this.setting.configuration.navBarConfiguration?.customNavActiveImageShortName);
      }

      // home icon
      if(this.setting.configuration.navBarConfiguration.homePageActiveImageShortName){
        this.appDefaultPages[0].imageActive = await this.navbarConfigurationService.fetchImage(this.setting.configuration.navBarConfiguration.homePageActiveImageShortName);
      }
      if(this.setting.configuration.navBarConfiguration.homePagePassiveImageShortName){
        this.appDefaultPages[0].imagePassive = await this.navbarConfigurationService.fetchImage(this.setting.configuration.navBarConfiguration.homePagePassiveImageShortName);
      }

      // store or order
      if(this.setting.configuration.navBarConfiguration.orderActiveImageShortName){
        this.appDefaultPages[1].imageActive = await this.navbarConfigurationService.fetchImage(this.setting.configuration.navBarConfiguration.orderActiveImageShortName);
      }
      if(this.setting.configuration.navBarConfiguration.orderPassiveImageShortName){
        this.appDefaultPages[1].imagePassive = await this.navbarConfigurationService.fetchImage(this.setting.configuration.navBarConfiguration.orderPassiveImageShortName);
      }

      // table order
      if(this.setting.configuration.navBarConfiguration.tableActiveImageShortName){
        this.appDefaultPages[2].imageActive = await this.navbarConfigurationService.fetchImage(this.setting.configuration.navBarConfiguration.tableActiveImageShortName);
      }
      if(this.setting.configuration.navBarConfiguration.tablePassiveImageShortName){
        this.appDefaultPages[2].imagePassive = await this.navbarConfigurationService.fetchImage(this.setting.configuration.navBarConfiguration.tablePassiveImageShortName);
      }

      // my order
      if(this.setting.configuration.navBarConfiguration.myOrderActiveImageShortName){
        this.appDefaultPages[3].imageActive = await this.navbarConfigurationService.fetchImage(this.setting.configuration.navBarConfiguration.myOrderActiveImageShortName);
      }
      if(this.setting.configuration.navBarConfiguration.myOrderPassiveImageShortName){
        this.appDefaultPages[3].imagePassive = await this.navbarConfigurationService.fetchImage(this.setting.configuration.navBarConfiguration.myOrderPassiveImageShortName);
      }

      // pay & reward (reward page)
      if(this.setting.configuration.navBarConfiguration.rewardsActiveImageShortName){
        this.appDefaultPages[4].imageActive = await this.navbarConfigurationService.fetchImage(this.setting.configuration.navBarConfiguration.rewardsActiveImageShortName);
      }
      if(this.setting.configuration.navBarConfiguration.rewardsPassiveImageShortName){
        this.appDefaultPages[4].imagePassive = await this.navbarConfigurationService.fetchImage(this.setting.configuration.navBarConfiguration.rewardsPassiveImageShortName);
      }

      // offers
      if(this.setting.configuration.navBarConfiguration.offersActiveImageShortName){
        this.appDefaultPages[5].imageActive = await this.navbarConfigurationService.fetchImage(this.setting.configuration.navBarConfiguration.offersActiveImageShortName);
      }
      if(this.setting.configuration.navBarConfiguration.offersPassiveImageShortName){
        this.appDefaultPages[5].imagePassive = await this.navbarConfigurationService.fetchImage(this.setting.configuration.navBarConfiguration.offersPassiveImageShortName);
      }

      // reservation
      if(this.setting.configuration.navBarConfiguration.reservationActiveImageShortName){
        this.appDefaultPages[6].imageActive = await this.navbarConfigurationService.fetchImage(this.setting.configuration.navBarConfiguration.reservationActiveImageShortName);
      }
      if(this.setting.configuration.navBarConfiguration.reservationPassiveImageShortName){
        this.appDefaultPages[6].imagePassive = await this.navbarConfigurationService.fetchImage(this.setting.configuration.navBarConfiguration.reservationPassiveImageShortName);
      }

      // locations
      if(this.setting.configuration.navBarConfiguration.locationsActiveImageShortName){
        this.appDefaultPages[7].imageActive = await this.navbarConfigurationService.fetchImage(this.setting.configuration.navBarConfiguration.locationsActiveImageShortName);
      }
      if(this.setting.configuration.navBarConfiguration.locationsPassiveImageShortName){
        this.appDefaultPages[7].imagePassive = await this.navbarConfigurationService.fetchImage(this.setting.configuration.navBarConfiguration.locationsPassiveImageShortName);
      }



      // account --- missing
      if(this.setting.configuration.navBarConfiguration.locationsActiveImageShortName){
        this.appDefaultPages[8].imageActive = await this.navbarConfigurationService.fetchImage(this.setting.configuration.navBarConfiguration.locationsActiveImageShortName);
      }
      if(this.setting.configuration.navBarConfiguration.locationsPassiveImageShortName){
        this.appDefaultPages[8].imagePassive = await this.navbarConfigurationService.fetchImage(this.setting.configuration.navBarConfiguration.locationsPassiveImageShortName);
      }



      // support
      if(this.setting.configuration.navBarConfiguration.contactUsActiveImageShortName){
        this.appDefaultPages[9].imageActive = await this.navbarConfigurationService.fetchImage(this.setting.configuration.navBarConfiguration.contactUsActiveImageShortName);
      }
      if(this.setting.configuration.navBarConfiguration.contactUsPassiveImageShortName){
        this.appDefaultPages[9].imagePassive = await this.navbarConfigurationService.fetchImage(this.setting.configuration.navBarConfiguration.contactUsPassiveImageShortName);
      }

      // profile
      if(this.setting.configuration.navBarConfiguration.profileActiveImageShortName){
        this.appDefaultPages[10].imageActive = await this.navbarConfigurationService.fetchImage(this.setting.configuration.navBarConfiguration.profileActiveImageShortName);
      }
      if(this.setting.configuration.navBarConfiguration.profilePassiveImageShortName){
        this.appDefaultPages[10].imagePassive = await this.navbarConfigurationService.fetchImage(this.setting.configuration.navBarConfiguration.profilePassiveImageShortName);
      }
 
      //console.log(this.appDefaultPages)

      this.ImageLoaded = true;
    } else {
      this.ImageLoaded = true;
    }

    
  }

  dynamicResizer(){
    var selectedCount = 0;
    for (var i = 0; i < this.appPages.length; i++) {
      if(!(this.appPages[i].show != undefined && !this.appPages[i].show(this) || this.PlaceOrderStatus(this.appPages))) {
        selectedCount++;
      }
    } 

    if(!(this.auth.isAuthenticated || this.setting.configuration.hideMemberProgram)) {
      selectedCount++;
    }

    if(this.auth.isAuthenticated){
      selectedCount++;
    }
    
    setInterval(() => {
      const hostElement = this.element.nativeElement;
      const host = hostElement;
  
      var numofrows = 1;

      // 63 for each box
      // 65 for the side of the menu
      var widthspace = window.innerWidth - 65;
      var totalrequiredWidth = selectedCount * 63;

      numofrows = Math.ceil(totalrequiredWidth  / widthspace);

      var TotalVal = `` + 50 * numofrows + `px`;
      host.style.setProperty('--navbar-maxheight', TotalVal);

      var MobileStartSize = `` + totalrequiredWidth + 65 + `px`
      host.style.setProperty('--mobile-sizing', MobileStartSize);
    }, 100);
  }

  IsPopup(pageDate) {

    
    try {
      if(pageDate.title == 'Nav.Stores' || pageDate.title == 'Nav.PlaceTableOrder') {
        if(pageDate.component && this.setting.configuration.uIoptions?.storeToPopup) {
          return true;
        }
      } else if(pageDate.title == 'Nav.Reservation') {
        if(pageDate.component && this.setting.configuration.uIoptions?.reservationToPopup) {
          return true;
        }
      } else if(pageDate.title == 'Nav.MyOrders') {
        if(pageDate.component && this.setting.configuration.uIoptions?.myOrdersToPopup) {
          return true;
        }
      } else if(pageDate.title == 'Nav.Offers') {
        if(pageDate.component && this.setting.configuration.uIoptions?.offersToPopup) {
          return true;
        }
      } else if(pageDate.title == 'Nav.Location' || pageDate.title == 'Nav.Locations') {
        if(pageDate.component && this.setting.configuration.uIoptions?.locationToPopup) {
          return true;
        }
      } else if(pageDate.title == 'Nav.Pay&Reward') {
        if(pageDate.component && this.setting.configuration.uIoptions?.rewardsToPopup) {
          return true;
        }
      } else if(pageDate.title == 'Nav.Profile') {
        if(pageDate.component && this.setting.configuration.uIoptions?.profileToPopup) {
          return true;
        }
      } else if(pageDate.title == 'Nav.Support') {
        if(pageDate.component && this.setting.configuration.uIoptions?.contactUsToPopup) {
          return true;
        }
      } else if(pageDate == 'Nav.Login') {
        if(this.setting.configuration.uIoptions?.loginToPopup) {
          return true;
        }
      }
    } catch (e) {

    }
    

    return false;
  }

  navigate(url: string, index: number) {
    this.selectedIndex = index;
    // Optional: reset Ionic nav stack if you want
    this.router.navigateByUrl(url);
  }
  
  async optionSelect(index, p) {
    console.log(p);
    /*
    if(this.isPopup) {
      this.modalCtrl.dismiss();
    }
    */

    let topModal = await this.modalCtrl.getTop();

    while (topModal) {
      await topModal.dismiss();
      topModal = await this.modalCtrl.getTop();
    }
    


    if(this.setting.openNav) {
      this.setting.toggleShowMore();
    }

    this.navbarConfigurationService.selectedNav = index;
    this.selectedIndex = index;
  }

  verifySize() {
    if(window.innerWidth > 858) {
      return true
    } else {
      if(this.setting.isAnimating) {
        this.setting.isAnimating = false;
      }
      return false;
    }

  }

  async OpenLoginModal() {
    if(this.setting.openNav) {
      this.setting.toggleShowMore();
    }

    if(this.setting.configuration.uIoptions?.loginToPopup) {
    
      // prevents crash if the undocked navbar is inside a popup
      if(this.isPopup) {
        this.modalCtrl.dismiss();
      }




      if(this.setting.configuration.uIoptions?.allinOneAuthPage) {
        // prevents crash if the undocked navbar is inside a popup
        const modal = await this.modalCtrl.create({
          component: AllInOneAuthPageComponent,
          cssClass: 'auth-popup-model',
          componentProps: {
            disableHeader: true,
            isPopup: true
          }
        });
      
        modal.onWillDismiss()
          .then((result) => {
            
        });
      
        await modal.present();
      } else {
        // prevents crash if the undocked navbar is inside a popup
        const modal = await this.modalCtrl.create({
          component: AuthenticationPageComponent,
          cssClass: 'auth-popup-model',
          componentProps: {
            disableHeader: true
          }
        });
      
        modal.onWillDismiss()
          .then((result) => {
            
        });
      
        await modal.present();
      }
    }
    
  }



  async ConfirmAndOpenModal(pageDate, index) {
    
    

    if(this.setting.openNav) {
      this.setting.toggleShowMore();
    }

    this.selectedIndex = index; 
    this.navbarConfigurationService.selectedNav = index;

    if(pageDate.title == 'Nav.Stores') {
      if(pageDate.component && this.setting.configuration.uIoptions?.storeToPopup && this.disabledOption != "Nav.Stores") {
      
        console.log("process here");

        // prevents crash if the undocked navbar is inside a popup
        /*
        if(this.isPopup) {
          this.modalCtrl.dismiss();
        }
        */
        let topModal = await this.modalCtrl.getTop();

        while (topModal) {
          await topModal.dismiss();
          topModal = await this.modalCtrl.getTop();
        }

        // this works but the process of changing store after picking an item is broken (assuming due to the new cart request)
        
        if(this.setting.configuration.uIoptions?.orderToMenuFirst){
          // here we'll open the menu first and allow the user to take an item. we do need to indicate that the store was not selected yet so that it shows up before checkout


          //navigate to the first store this merchant has so it can lay a menu (only if it's not already on a menu)
          if (!this.router.url.includes('/stores/menu')) {
            this.storeService.getStores(false, "standard")
            .pipe(take(1))
            .subscribe(async (data: IStore[]) => {
              var stores = data;

              const target = '/stores/menu/' + data[0].id + '/pickup';

              // wait for Angular + Ionic to finish current cycle
              await new Promise(resolve => setTimeout(resolve, 0));


              console.log('User clicked to navigate:', stores[0].id, new Error().stack);
              //this.safeNavigate('/stores/menu/' + stores[0].id + '/pickup');
              this.safeNavigate(target);
              //this.navCtrl.navigateRoot('/stores/menu/' + stores[0].id + '/pickup');
            });
          }

          // in the storeService, there will be a value that will track whether the store was selected manually or not
          this.storeService.setSelectedStore = false;
          
        } else {


          const modal = await this.modalCtrl.create({
            component: pageDate.component,
            cssClass: 'store-popup-model',
            componentProps: {
              isTableOrder: false,
              disableHeader: true
            }
          });

          
          //navigate to the first store this merchant has so it can lay a menu in the background (only if it's not already on a menu)
          if (!this.router.url.includes('/stores/menu')) {
            this.storeService.getStores()
            .pipe(take(1))
            .subscribe(async (data: IStore[]) => {
              var stores = data;

              const target = '/stores/menu/' + data[0].id + '/pickup';

              // wait for Angular + Ionic to finish current cycle
              await new Promise(resolve => setTimeout(resolve, 0));

              this.safeNavigate(target);
    
              console.log('User clicked to navigate:', stores[0].id, new Error().stack);
              //this.safeNavigate('/stores/menu/' + stores[0].id + '/pickup');
              this.safeNavigate(target);
              //this.navCtrl.navigateRoot('/stores/menu/' + stores[0].id + '/pickup');
            });
          }

          await modal.present();

          const { data } = await modal.onDidDismiss();

          if(data?.route){
            this.safeNavigate('/stores' + data.route);
            //this.navCtrl.navigateRoot(['/stores' + data.route]);
          }
        }
        

        /*
        const modal = await this.modalCtrl.create({
          component: pageDate.component,
          cssClass: 'store-popup-model',
          componentProps: {
            isTableOrder: false,
            disableHeader: true
          }
        });

        //navigate to the first store this merchant has so it can lay a menu in the background (only if it's not already on a menu)
        if (!this.router.url.includes('/stores/menu')) {
          this.storeService.getStores().subscribe((data: IStore[]) => {
            var stores = data;
  
            this.navCtrl.navigateRoot('/stores/menu/' + stores[0].id + '/pickup');
          });
        }

        await modal.present();

        const { data } = await modal.onDidDismiss();

        if(data?.route){
          this.navCtrl.navigateRoot(['/stores' + data.route]);
        }
          */
        
      }
    } else if (pageDate.title == 'Nav.PlaceTableOrder') {
      if(pageDate.component && this.setting.configuration.uIoptions?.storeToPopup && this.disabledOption != "Nav.Stores") {
      
        // prevents crash if the undocked navbar is inside a popup
        /*
        if(this.isPopup) {
          this.modalCtrl.dismiss();
        }
        */
        let topModal = await this.modalCtrl.getTop();

        while (topModal) {
          await topModal.dismiss();
          topModal = await this.modalCtrl.getTop();
        }

        const modal = await this.modalCtrl.create({
          component: pageDate.component,
          cssClass: 'store-popup-model',
          componentProps: {
            isTableOrder: true,
            disableHeader: true
          }
        });

        //navigate to the first store this merchant has so it can lay a menu in the background (only if it's not already on a menu)
        if (!this.router.url.includes('/stores/menu')) {
          this.storeService.getStores()
          .pipe(take(1))
          .subscribe((data: IStore[]) => {
            var stores = data;

            this.safeNavigate('/stores/menu/' + stores[0].id + '/pickup');
            //this.navCtrl.navigateRoot('/stores/menu/' + stores[0].id + '/pickup');
          });
        }
      
        await modal.present();

        const { data } = await modal.onDidDismiss();

        if(data?.route){
          this.safeNavigate('/stores' + data.route);
          //this.navCtrl.navigateRoot('/stores' + data.route);
        }
      }
    } else if(pageDate.title == 'Nav.Reservation') {
      if(pageDate.component && this.setting.configuration.uIoptions?.reservationToPopup && this.disabledOption != "Nav.Reservation") {

        // prevents crash if the undocked navbar is inside a popup
        /*
        if(this.isPopup) {
          this.modalCtrl.dismiss();
        }
        */
        let topModal = await this.modalCtrl.getTop();

        while (topModal) {
          await topModal.dismiss();
          topModal = await this.modalCtrl.getTop();
        }
      
        const modal = await this.modalCtrl.create({
          component: pageDate.component,
          cssClass: 'reservation-popup-model',
          componentProps: {
            disableHeader: true
          }
        });
      
        modal.onWillDismiss()
          .then((result) => {
            
        });
      
        await modal.present();
      }
    } else if(pageDate.title == 'Nav.MyOrders') {
      if(pageDate.component && this.setting.configuration.uIoptions?.myOrdersToPopup && this.disabledOption != "Nav.MyOrders") {
      
        // prevents crash if the undocked navbar is inside a popup
        /*
        if(this.isPopup) {
          this.modalCtrl.dismiss();
        }
        */
        let topModal = await this.modalCtrl.getTop();

        while (topModal) {
          await topModal.dismiss();
          topModal = await this.modalCtrl.getTop();
        }
        

        const modal = await this.modalCtrl.create({
          component: pageDate.component,
          cssClass: 'myorders-popup-model',
          componentProps: {
            disableHeader: true
          }
        });
      
        modal.onWillDismiss()
          .then((result) => {
            
        });
      
        await modal.present();
      }
    } else if(pageDate.title == 'Nav.Offers') {
      if(pageDate.component && this.setting.configuration.uIoptions?.offersToPopup && this.disabledOption != "Nav.Offers") {
      
        // prevents crash if the undocked navbar is inside a popup
        /*
        if(this.isPopup) {
          this.modalCtrl.dismiss();
        }
        */

        let topModal = await this.modalCtrl.getTop();

        while (topModal) {
          await topModal.dismiss();
          topModal = await this.modalCtrl.getTop();
        }

        if(!this.authService.isAuthenticated) {
          if(this.setting.configuration.uIoptions?.loginToPopup) {
          
            // prevents crash if the undocked navbar is inside a popup
            if(this.setting.configuration.uIoptions?.allinOneAuthPage) {
              // prevents crash if the undocked navbar is inside a popup
              const modal = await this.modalCtrl.create({
                component: AllInOneAuthPageComponent,
                cssClass: 'auth-popup-model',
                componentProps: {
                  disableHeader: true,
                  isPopup: true
                }
              });
            
              modal.onWillDismiss()
                .then((result) => {
                  
              });
            
              await modal.present();
            } else {
              // prevents crash if the undocked navbar is inside a popup
              const modal = await this.modalCtrl.create({
                component: AuthenticationPageComponent,
                cssClass: 'auth-popup-model',
                componentProps: {
                  disableHeader: true
                }
              });
            
              modal.onWillDismiss()
                .then((result) => {
                  
              });
            
              await modal.present();
            }

            return;
          } else {
            if(this.setting.configuration.uIoptions?.allinOneAuthPage) { 
              this.router.navigate(['auth/fullauth']);
            } else {
              this.router.navigate(['auth']);
            }
            return;
          }
        }

        const modal = await this.modalCtrl.create({
          component: pageDate.component,
          cssClass: 'offers-popup-model',
          componentProps: {
            disableHeader: true
          }
        });
      
        modal.onWillDismiss()
          .then((result) => {
            
        });
      
        await modal.present();
      }
    } else if(pageDate.title == 'Nav.Location' || pageDate.title == 'Nav.Locations') {
      if(pageDate.component && this.setting.configuration.uIoptions?.locationToPopup && this.disabledOption != "Nav.Locations") {
      
        // prevents crash if the undocked navbar is inside a popup
        /*
        if(this.isPopup) {
          this.modalCtrl.dismiss();
        }
        */
        let topModal = await this.modalCtrl.getTop();

        while (topModal) {
          await topModal.dismiss();
          topModal = await this.modalCtrl.getTop();
        }

        const modal = await this.modalCtrl.create({
          component: pageDate.component,
          cssClass: 'location-popup-model',
          componentProps: {
            disableHeader: true
          }
        });
      
        modal.onWillDismiss()
          .then((result) => {
            
        });
      
        await modal.present();
      }
    } else if(pageDate.title == 'Nav.Pay&Reward') {
      if(pageDate.component && this.setting.configuration.uIoptions?.rewardsToPopup && this.disabledOption != "Nav.Pay&Reward") {
      
        // prevents crash if the undocked navbar is inside a popup
        /*
        if(this.isPopup) {
          await this.modalCtrl.dismiss();
        }
        */
        let topModal = await this.modalCtrl.getTop();

        while (topModal) {
          await topModal.dismiss();
          topModal = await this.modalCtrl.getTop();
        }

        if(!this.authService.isAuthenticated && !this.setting.configuration?.uIoptions?.extendedRewards) {
          if(this.setting.configuration.uIoptions?.loginToPopup) {
          
            if(this.setting.configuration.uIoptions?.allinOneAuthPage) {
              // prevents crash if the undocked navbar is inside a popup
              const modal = await this.modalCtrl.create({
                component: AllInOneAuthPageComponent,
                cssClass: 'auth-popup-model',
                componentProps: {
                  disableHeader: true,
                  isPopup: true
                }
              });
            
              modal.onWillDismiss()
                .then((result) => {
                  
              });
            
              await modal.present();
            } else {
              // prevents crash if the undocked navbar is inside a popup
              const modal = await this.modalCtrl.create({
                component: AuthenticationPageComponent,
                cssClass: 'auth-popup-model',
                componentProps: {
                  disableHeader: true
                }
              });
            
              modal.onWillDismiss()
                .then((result) => {
                  
              });
            
              await modal.present();
            }
            
            return;
          } else {
            if(this.setting.configuration.uIoptions?.allinOneAuthPage) { 
              this.router.navigate(['auth/fullauth']);
            } else {
              this.router.navigate(['auth']);
            }
            
            return;
          }
        }

        const modal = await this.modalCtrl.create({
          component: pageDate.component,
          cssClass: 'reward-popup-model',
          componentProps: {
            disableHeader: true
          }
        });
      
        modal.onWillDismiss()
          .then((result) => {
            
        });
      
        await modal.present();
      }
    } else if(pageDate.title == 'Nav.Profile') {
      if(pageDate.component && this.setting.configuration.uIoptions?.profileToPopup && this.disabledOption != "Nav.Profile") {

        // prevents crash if the undocked navbar is inside a popup
        /*
        if(this.isPopup) {
          this.modalCtrl.dismiss();
        }
        */
        let topModal = await this.modalCtrl.getTop();

        while (topModal) {
          await topModal.dismiss();
          topModal = await this.modalCtrl.getTop();
        }  


        if(!this.authService.isAuthenticated && !this.setting.configuration.uIoptions?.extendedSettings) {
          if(this.setting.configuration.uIoptions?.loginToPopup) {
            if(this.setting.configuration.uIoptions?.allinOneAuthPage) {
              // prevents crash if the undocked navbar is inside a popup
              const modal = await this.modalCtrl.create({
                component: AllInOneAuthPageComponent,
                cssClass: 'auth-popup-model',
                componentProps: {
                  disableHeader: true,
                  isPopup: true
                }
              });
            
              modal.onWillDismiss()
                .then((result) => {
                  
              });
            
              await modal.present();
            } else {
              // prevents crash if the undocked navbar is inside a popup
              const modal = await this.modalCtrl.create({
                component: AuthenticationPageComponent,
                cssClass: 'auth-popup-model',
                componentProps: {
                  disableHeader: true
                }
              });
            
              modal.onWillDismiss()
                .then((result) => {
                  
              });
            
              await modal.present();
            }
            return;
          } else {
            if(this.setting.configuration.uIoptions?.allinOneAuthPage) { 
              this.router.navigate(['auth/fullauth']);
            } else {
              this.router.navigate(['auth']);
            }
            return;
          }
        }

        const modal = await this.modalCtrl.create({
          component: pageDate.component,
          cssClass: 'profile-popup-model',
          componentProps: {
            disableHeader: true
          }
        });
      
        modal.onWillDismiss()
          .then((result) => {
            
        });
      
        await modal.present();
      }
    } else if(pageDate.title == 'Nav.Support') {
      if(pageDate.component && this.setting.configuration.uIoptions?.contactUsToPopup && this.disabledOption != "Nav.Support") {
        
        // prevents crash if the undocked navbar is inside a popup
        /*
        if(this.isPopup) {
          this.modalCtrl.dismiss();
        }
        */
        let topModal = await this.modalCtrl.getTop();

        while (topModal) {
          await topModal.dismiss();
          topModal = await this.modalCtrl.getTop();
        }
        
        const modal = await this.modalCtrl.create({
          component: pageDate.component,
          cssClass: 'support-popup-model',
          componentProps: {
            disableHeader: true
          }
        });
      
        modal.onWillDismiss()
          .then((result) => {
            
        });
      
        await modal.present();
      }
    }
  }

  async safeNavigate(url: string) {
    if (this.navigating) return;
    if (this.router.url === url){
      if(url.includes("/stores/menu/") && localStorage.getItem('orderDateTime') != null){
          this.menuService.refreshMenu();
      }
      return;
    } 

    this.navigating = true;

    
    await this.navCtrl.navigateRoot(url);

    setTimeout(() => {
      this.navigating = false;
    }, 300);
  }

   getAvailableCoupons() {
      // Make call to service
      let offers = [];
      let coupons = [];
      
      if(!this.setting.configuration) return;

      coupons = this.couponService.processCouponAvailability();

      // Get offers from service via getItems() method
      if(!this.setting.configuration.hideMemberProgram) {
        this.accountService.$primary
            .subscribe((primary) => {
              this.primary = primary;
              this.accountService.getItems(this.primary.ApiAccountId, true)
                  .subscribe(
                    (data) => {
                      offers = data
                    }
                  )
            })
      } 
      
      // Wait for response from service before setting notification and pop-up message
      setTimeout(() => {

        // If notification already set, load offers badge value from local storage
        if(localStorage.getItem('OffersAvailable') && localStorage.getItem('OffersAvailable') != undefined) {
          for(let i = 0; i < this.appPages.length; i++){
            if(this.appPages[i].title == 'Nav.Offers') this.appPages[i].notification = JSON.parse(localStorage.getItem('Offers Available'));
          }
        }
        for(let i = 0; i < this.appPages.length; i++){
          if(this.appPages[i].title == 'Nav.Offers'
          && JSON.parse(localStorage.getItem('Offers Available')) != coupons.length + offers.length){
            this.appPages[i].notification = coupons.length + offers.length;
            localStorage.setItem('OffersAvailable', JSON.stringify(coupons.length + offers.length));
          }
          if((coupons.length && offers.length) && !localStorage.getItem('OffersAvailable')) {
            localStorage.setItem('OffersAvailable', JSON.stringify(coupons.length + offers.length));
          }
          
        }
        
      // update local storage
      localStorage.setItem('coupons', JSON.stringify(coupons));
 
    }, 5000);

    // check local storage every 5 seconds to check for change in number of coupons, update number if changed.
    setInterval(() => {
      let numberOfCoupons = JSON.parse(localStorage.getItem('coupons')).length;
      for(let i = 0; i < this.appPages.length; i++){
        if(this.appPages[i].title == 'Nav.Offers' && numberOfCoupons != this.appPages[i].notification ) {
          this.appPages[i].notification = numberOfCoupons + offers.length;
          localStorage.setItem('OffersAvailable', JSON.stringify(coupons.length + offers.length))
        }
      }
    }, 5000)
    
  }



  fontStyle()
  {
    let fontName = this.setting.configuration.customFont.name;
    let fontUrl = this.setting.configuration.customFont.link;
    let link=document.createElement('link');
    let style = document.createElement('style');
    style.innerText = "@font-face { font-family: " + fontName + " } body {--ion-font-family:  " + fontName + " !important;font-family:  " + fontName + " !important}"
    link.href=fontUrl;
    link.rel="stylesheet"
    document.getElementsByTagName('head')[0].appendChild(style);
    document.getElementsByTagName('head')[0].appendChild(link)
  }



  async logout() {
    const actionSheet = await this.actionSheetController.create({
      header: this.translationService.translate('Auth.LogoutConfirmation'),
      buttons: [{
        text: this.translationService.translate('General.Yes'),
        handler: () => {
          // when the use logs out
          this.analytics.conversionUpdate("logOut");

          this.auth.logout();
          this.router.navigateByUrl('');

          //gotta clear the linkCoupon in case another account log in and try to link some promotion.
          localStorage.removeItem('linkCoupon');
        }
      },
      {
        text: this.translationService.translate('General.No'),
        role: 'cancel'
      }]
    });

    actionSheet.present();
  }
  onClick(e: any)
  {
    this.selectedIndex=e;
  }
  changeLang(lang: string) {

    localStorage['lang'] = lang;
    this.translationService.setLanguage(lang.toLowerCase());
  }

  clearCache() {
    this.storage.remove(AccountService.primaryStorageKey);
    this.storage.remove(ProfileService.profileStorageKey);
    this.storage.remove(SettingService.configurationStorageKey);
    this.storage.remove(PageService.homeImagesStorageKey);
  } 

  /*
  toggle()  
  { 
    if(this.isAnimating) {
      this.isAnimating = false;
    } else {
      this.isAnimating = true;
      this.openNav = false;
    }
    
  }

  toggleShowMore() {
    if(this.openNav) {
      this.openNav = false;
    } else {
      this.openNav = true;
    }
  }
  */
 
  previewMenuMode:boolean;
  previewPageMode() {
    const substring = "preview";
    //window.location.pathname.includes(substring)
    if (window.location.hostname.includes(substring)) {
      this.previewMenuMode = true;
      this.appPages = this.appPreviewPages;
      //this.editNavigation();
    }
    else{
      this.previewMenuMode = false; 
      this.storage.set('previewMenuMode',this.previewMenuMode);
      //this.appPages = this.appDefaultPages;
      this.editNavigation();
    }


      this.storage['previewMenuMode'] = this.previewMenuMode
      //console.log("there2");
      //console.log(this.previewMenuMode);
      //console.log(this.storage['previewMenuMode']);

  }

  PlaceOrderStatus(p) {

    if("Nav.PlaceTableOrder" === p.title || "Nav.Stores" === p.title || "Nav.MyOrders" === p.title /* || "Nav.Reservation" === p.title*/) {

      return this.setting.configuration.hidePlaceanOrder;

    } else if("Nav.Offers" === p.title) {
      return this.setting.configuration.hideECouponProgram;
    } else if("Nav.Account" === p.title) {
      return true;
    } else {
      return false;
    }
  }

}
